import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import errorImage from '../../../../assets/images/error_image.svg';

export default class RssFeedErrorItem extends PureComponent {
  render() {
    return (
      <div className="glu-content__section glu-content__separator glu-content__separator--inner">
        <div className="glu-flex glu-flex-row glu-flex-align-center">
          <div className="glu-flex-shrink">
            <img className="glu-widget__image" src={errorImage} alt="" />
          </div>
          <div className="glu-flex-grow">
            <div className="rss-error-title">Something went wrong with this feed</div>
            <div className="rss-description">
              Check the source
              {this.props.isEditAllowed && (
                <>
                  <span>&nbsp;URL in the</span>
                  <span
                    className="open-widget-configuration"
                    onClick={this.props.openConfiguration}
                  >
                    configuration
                  </span>
                </>
              )}
            </div>
            <div className="rss-error-source">Source: {this.props.url}</div>
          </div>
        </div>
      </div>
    );
  }
}

RssFeedErrorItem.propTypes = {
  url: PropTypes.string.isRequired,
  openConfiguration: PropTypes.func.isRequired,
  isEditAllowed: PropTypes.bool,
};

RssFeedErrorItem.defaultProps = {
  isEditAllowed: false,
};
